import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button, Card, TextField, InputAdornment } from '@mui/material';
import PropTypes from 'prop-types';
import { ViewTitle } from '../../components/ViewTitle';

import * as actions from '../../redux/actions';
import Loading from '../../components/Loading';
import { Error } from '../../components/Error';
import { JobTable, ZonePriceTable } from '../../components/Table';

function Pricings({ title, subtitle }) {
  const dispatch = useDispatch();
  const zonePrice = useSelector((state) => state.zonePrice);

  const [searchTerm, setSearchTerm] = useState('');
  const [name, setName] = useState('');
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [total, setTotal] = useState(undefined);

  useEffect(() => {
    dispatch(actions.zonePriceAll({ name, page, size }));
  }, [name, page, size]);

  useEffect(() => {
    setTotal(zonePrice?.total);
    return () => {};
  }, [zonePrice]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setName(searchTerm);
      setPage(1);
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const tableFunction = {
    handleChangePage: (event, newPage) => {
      setPage(newPage + 1);
    },
    handleChangeRowsPerPage: (event) => {
      setSize(event.target.value);
      setPage(1);
    },
    handleDelete: async (id) => {
      const confirm = window.confirm('ยืนยันการลบโซนราคานี้');
      if (confirm) {
        await dispatch(actions.zonePriceDelete(id));
        await dispatch(actions.zonePriceAll({ name, page, size }));
      }
    },
    page,
    size,
    total,
    zonePrices: zonePrice?.rows,
  };

  const renderTitle = () => (
    <div className="flex flex-row justify-between ">
      <ViewTitle title={title} subtitle={subtitle} />{' '}
      <Link to="pricing/create" className="self-center">
        <Button variant="contained">เพิ่ม</Button>
      </Link>
    </div>
  );

  const renderSearch = () => (
    <Card>
      <div className="p-4 flex flex-row">
        <div className="w-full md:w-1/2">
          <TextField
            label="ค้นหา"
            fullWidth
            size={'small'}
            id="outlined-start-adornment"
            onChange={(e) => {
              setSearchTerm(e.target.value);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <i className="fas fa-search"></i>
                </InputAdornment>
              ),
            }}
          />
        </div>
      </div>
    </Card>
  );

  const renderTable = () => (
    <div className="my-4">
      <ZonePriceTable {...tableFunction} />
    </div>
  );

  if (zonePrice.isLoading) {
    return <Loading />;
  }
  if (!zonePrice.isLoading && zonePrice.isCompleted) {
    return (
      <div>
        {renderTitle()}
        {renderSearch()}
        {renderTable()}
      </div>
    );
  }
  return <Error />;
}

Pricings.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

Pricings.defaultProps = {
  title: '',
  subtitle: '',
};

export default Pricings;
